module.exports = __webpack_public_path__ + "static/media/Dnif_Icon.8daea684.svg";